import { borders, colors, weights } from "lib/theme";
import React from "react";
import ReactLoading from "react-loading";
import styled, { css } from "styled-components";
import { flex, maxWidth, minWidth, space, width } from "styled-system";

const Container = styled.div`
  position: relative;
  ${width};
  ${space};
  ${flex};
  ${maxWidth};

  ${(p) => p.inline && `display: inline-block;`}
`;

const ButtonStyled = styled.button`
  ${width};
  ${space};
  ${minWidth};

  margin: 0;
  user-select: none;

  display: inline-block;
  position: relative; // for arrows
  max-width: 100%;

  border-radius: ${borders.radiusSuperLarge};
  text-align: center;
  // So all buttons size the same regardless of border
  border: ${borders.thickness} solid transparent;

  font-size: 16px;
  line-height: 24px;
  color: ${colors.white};
  font-weight: ${weights.bold};
  background-color: ${(p) => colors[p.color] || p.color};
  -webkit-appearance: none;
  white-space: nowrap;

  transition: 0.15s ease-out box-shadow;

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px ${colors.pink[200]};
  }

  ${(p) => p.as === "a" && `text-decoration: none`};
  ${(p) => p.as !== "a" && `cursor: pointer`};

  ${(p) =>
    p.secondary &&
    `
      background-color: ${colors.gray[600]};
    `}

  ${(p) =>
    p.error &&
    `
      cursor: not-allowed;
      background-color: ${colors.navy[50]};

      &:focus {
        box-shadow: 0 0 0 3px ${colors.navy[100]};
      }
    `}
  ${(p) =>
    p.loading &&
    `
      cursor: wait;
      background-color: ${colors.gray[500]};
      color: transparent;

      &:focus {
        box-shadow: 0 0 0 3px ${colors.gray[500]};
      }
    `}
  ${(p) =>
    (p.outline || p.info) &&
    `
      background-color: white;
      color: ${colors.navy[500]};
      border: ${borders.thickness} solid ${colors.gray[500]};
    `}
  ${(p) =>
    p.ready &&
    `
      background-color: ${colors.blue[500]};

      &:focus {
        box-shadow: 0 0 0 3px ${colors.blue[600]};
      }

    `}
  ${(p) =>
    p.small &&
    `
      padding: 10px;
    `}

  ${(p) =>
    p.ghost &&
    css`
      transition: background 150ms;
      outline: none;
      background: transparent;

      &:active {
        background: ${(p) => p.color};
      }

      &:focus {
        box-shadow: 0 0 0 3px ${colors.gray[300]};
      }
    `}
`;

const LoadingWrapper = styled.span`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: white;
`;

const Loading = () => (
  <LoadingWrapper>
    <ReactLoading type="bubbles" />
  </LoadingWrapper>
);
class Button extends React.Component<any> {
  render() {
    const {
      loading,
      type,
      as,
      p,
      px,
      py,
      pt,
      pb,
      pl,
      pr,
      onClick,
      "data-cy": dataCy,
      ...containerProps
    } = this.props;
    const { m, mx, my, mt, mb, ml, mr, ...buttonProps } = this.props;
    return (
      <Container {...containerProps}>
        <ButtonStyled
          {...buttonProps}
          as={this.props.as || (this.props.asLink && "a")}
        />
        {loading ? <Loading /> : undefined}
      </Container>
    );
  }
}

Button.defaultProps = {
  color: colors.pink[500],
  p: ["14px 15px", "14px 28px"],
  width: "100%",
  minWidth: "120px",
  height: "44px",
};

export default Button;
